'use client';

import { PoolsLayout } from '@/components/Pools/PoolsLayout';

export default function PoolsPage() {
  return <PoolsLayout />;
}
